import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Rating } from "primereact/rating";
import { Tag } from "primereact/tag";
import { useParams } from "react-router-dom";
import { TabView, TabPanel } from "primereact/tabview";
import {
  API_GET_COMPANYBYID,
  API_GET_SUBSCRIPTION,
  API_GET_WABAHEALTH,
} from "../../api/company.service";
import { Fieldset } from "primereact/fieldset";
import { DataView } from "primereact/dataview";
import { Chip } from "primereact/chip";
import { Message } from "primereact/message";
import { WabaHealth } from "./wabaHealth";
import "./company.css";

export const BusinessInfo = () => {
  const { companyId } = useParams();
  const [company, setCompany] = useState({});
  //const [subscription, setSubscription] = useState({});

  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        const companyData = await API_GET_COMPANYBYID(companyId);
        setCompany(companyData);
      } catch (error) {
        console.error("Failed to fetch company data:", error);
      }
    };

    if (companyId) {
      fetchCompanyData();
    }
  }, [companyId]);

  return (
    <>
      <div className="section1">
        <Fieldset legend="Waba Health">
          <WabaHealth />
        </Fieldset>
      </div>
      <Fieldset legend="Company Info">
        <div className="card flex flex-wrap">
          {company &&
            Object.entries(company).map(([key, value]) => {
              // console.log(key, value);
              return (
                <Message
                  severity="secondary"
                  text={key + " : " + value}
                  style={{
                    minWidth: "22rem",
                    borderRightColor: "black",
                    display: "inline",
                  }}
                />
              );
            })}
        </div>
      </Fieldset>
    </>
  );
};
